export const FETCH_RESERVATION_RULESETS_REQUEST = 'FETCH_RESERVATION_RULESETS_REQUEST';
export const FETCH_RESERVATION_RULESETS_SUCCESS = 'FETCH_RESERVATION_RULESETS_SUCCESS';
export const FETCH_RESERVATION_RULESETS_FAILED = 'FETCH_RESERVATION_RULESETS_FAILED';

export const FETCH_RESERVATION_RULESET_BY_ID_REQUEST = 'FETCH_RESERVATION_RULESET_BY_ID_REQUEST';
export const FETCH_RESERVATION_RULESET_BY_ID_SUCCESS = 'FETCH_RESERVATION_RULESET_BY_ID_SUCCESS';
export const FETCH_RESERVATION_RULESET_BY_ID_FAILED = 'FETCH_RESERVATION_RULESET_BY_ID_FAILED';

export const CREATE_RESERVATION_RULESET_REQUEST = 'CREATE_RESERVATION_RULESET_REQUEST';
export const CREATE_RESERVATION_RULESET_SUCCESS = 'CREATE_RESERVATION_RULESET_SUCCESS';
export const CREATE_RESERVATION_RULESET_FAILED = 'CREATE_RESERVATION_RULESET_FAILED';

export const UPDATE_RESERVATION_RULESET_REQUEST = 'UPDATE_RESERVATION_RULESET_REQUEST';
export const UPDATE_RESERVATION_RULESET_SUCCESS = 'UPDATE_RESERVATION_RULESET_SUCCESS';
export const UPDATE_RESERVATION_RULESET_FAILED = 'UPDATE_RESERVATION_RULESET_FAILED';

export const DELETE_RESERVATION_RULESET_REQUEST = 'DELETE_RESERVATION_RULESET_REQUEST';
export const DELETE_RESERVATION_RULESET_SUCCESS = 'DELETE_RESERVATION_RULESET_SUCCESS';
export const DELETE_RESERVATION_RULESET_FAILED = 'DELETE_RESERVATION_RULESET_FAILED';

export const RESET_CURRENT_RESERVATION_RULESET = 'RESET_CURRENT_RESERVATION_RULESET';

export const FETCH_UPDATE_RESERVATION_RULESET_INFO_SUCCESS =
  'FETCH_UPDATE_RESERVATION_RULESET_INFO_SUCCESS';
